import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d97f532"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xcare-type" }
const _hoisted_2 = {
  key: 1,
  class: "list-mode-wrap"
}
const _hoisted_3 = {
  key: 1,
  class: "no-tag"
}
const _hoisted_4 = {
  key: 2,
  class: "xcare-time"
}
const _hoisted_5 = {
  key: 1,
  class: "xcare-time"
}
const _hoisted_6 = {
  key: 2,
  class: "out-quality-icon"
}
const _hoisted_7 = {
  key: 3,
  class: "tags-info-wrap"
}

import { xcareTypeClassNameMap } from './service-tag'
import { isValueAddService } from '@/defination/malfunction-repair'
import { withDefaults, computed, ComputedRef } from 'vue'
import dayjs from 'dayjs'

interface DetailIngoListItem {
  time?: string
  className?: string[]
  isOutQuality?: boolean
}
/*
  列表模式
    1、优先显示增值服务和时间
    2、无增值服务但是质保在保显示质保期
    3、无增值服且质保过期：产品已过保，且无增值服务。

*/

export default /*#__PURE__*/_defineComponent({
  __name: 'xcare-type-tag',
  props: {
    is_quality: null,
    xcare_type: null,
    activate_at: null,
    xcare: null,
    mode: { default: 'list' },
    quality: null
  },
  setup(__props: any) {

const props = __props as { is_quality: number, xcare_type: string, activate_at: string, xcare: string, mode: string, quality: string };


const isListMode = computed(() => props.mode === 'list')
const isOnlyTagMode = computed(() => props.mode === 'onlyTag')
const isOnlyTagsMode = computed(() => props.mode === 'onlyTags')
const isDetailMode = computed(() => props.mode === 'detail')
const hasXCareType = computed(() => isValueAddService(props.xcare_type))
const hasQuality = computed(() => props.is_quality === 1)
const listNoTag = computed(() => !hasXCareType.value && !hasQuality.value)
const qualityTimeRange = computed(() => {
  try {
    const startTime = props.activate_at.split(' ')[0]
    const startTimeArr = startTime.split('-')
    startTimeArr[0] = String(Number(startTimeArr[0]) + 1)
    const nextTimeYear = startTimeArr.join('-')
    const endTime = dayjs(dayjs(nextTimeYear).valueOf() - 1).format('YYYY-MM-DD')
    return `${startTime}-${endTime}`
  } catch (error) {
    console.log('error', error)
    return ''
  }
})
const listTagTime = computed(() => {
  if (hasXCareType.value) {
    return props.xcare
  }
  return props.quality
})

const listModeClassName = computed(() => {
  let result: string[] = ['base-type']
  if (hasXCareType.value) {
    // 有增值服务的时候
    result = result.concat(xcareTypeClassNameMap[props.xcare_type])
  } else if (hasQuality.value) {
    // 无增值服务但有质保的时候
    result.push('quality-in-tag')
  }
  return result.join(' ')
})

const detailInfoList: ComputedRef<Array<DetailIngoListItem>> = computed(() => {
  if (!isDetailMode.value && !isOnlyTagsMode.value) {
    return []
  }
  if (!hasXCareType.value && props.is_quality === 0) {
    // 质保未知与没有增值服务时
    return [{}]
  }
  const result: DetailIngoListItem[] = []
  if (hasXCareType.value) {
    result.push({
      className: xcareTypeClassNameMap[props.xcare_type],
      time: props.xcare,
    })
  }
  if (props.is_quality !== 0) {
    result.push({
      time: props.quality,
      className: hasQuality.value ? ['quality-in-tag'] : ['red-bg ', 'quality-out-tag'], // tag样式来自service-tag.scss
      isOutQuality: props.is_quality === 2,
    })
  }
  console.log('result', result)
  return result
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isOnlyTagMode) && !_unref(listNoTag))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["tag-wrap", _unref(listModeClassName)])
        }, null, 2))
      : _createCommentVNode("", true),
    (_unref(isListMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_unref(listNoTag))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["tag-wrap", _unref(listModeClassName)])
              }, null, 2))
            : _createCommentVNode("", true),
          (_unref(listNoTag))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "产品已过保，且无增值服务。"))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(listTagTime)), 1))
        ]))
      : _createCommentVNode("", true),
    (_unref(isDetailMode))
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(detailInfoList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "detail-info-item",
            key: index
          }, [
            (item.className)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["tag-wrap base-type", item.className])
                }, null, 2))
              : _createCommentVNode("", true),
            (item.time)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.time), 1))
              : _createCommentVNode("", true),
            (item.isOutQuality)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      : _createCommentVNode("", true),
    (_unref(isOnlyTagsMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detailInfoList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "detail-info-item",
              key: index
            }, [
              (item.className)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["tag-wrap base-type", item.className])
                  }, null, 2))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})